import styled from 'styled-components';
import {typographyStyles} from '../../../../utils/styles';

const StyledBudgetPreviewLegendAmount = styled.div`
  ${typographyStyles.footnote.medium};
  color: ${props => props.theme.colors.neutral_10};
  text-wrap: nowrap;
`;

const StyledBudgetPreviewLegendDot = styled.span`
  background-color: ${props => props.color};
  border-radius: 45px;
  box-shadow: 0px 3.2px 6.4px 0 #7A8AFF26;
  display: inline-block;
  height: 8px;
  width: 8px;
`;

const StyledBudgetPreviewLegendTitle = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_8};
`;


export {
  StyledBudgetPreviewLegendAmount,
  StyledBudgetPreviewLegendDot,
  StyledBudgetPreviewLegendTitle,
}
